export default {
    state: {
        valid: false,
        validate: false
    },

    mutations: {
        VALIDATE(state, payload) {
            state.validate = payload
        },
        IS_VALID(state, payload) {
            state.valid = payload
        }
    },

    getters: {
        VALIDATING(state) {
            return state.validate
        },
        FORM_VALID(state) {
            return state.valid
        }
    }
}